import { type FC, type MouseEventHandler } from 'react';
import { Button } from '@mantine/core';
import { useAcceptPayoutOrder } from '~/entities/payout';

type AcceptOrderProps = {
    id: string;
    disabled?: boolean;
    onSuccess?: () => void;
    onError?: (error: Error) => void;
};

export const AcceptOrder: FC<AcceptOrderProps> = ({ id, disabled, onSuccess, onError }) => {
    const { mutate, isPending } = useAcceptPayoutOrder({ onSuccess, onError });

    const handleAccept: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();

        mutate({
            orderId: {
                value: id,
            },
        });
    };

    return (
        <Button
            title='Принять'
            loading={isPending}
            onClick={handleAccept}
            disabled={isPending || disabled}
        >
            Принять
        </Button>
    );
};
